<template>
  <div class="category"
    :style="{
    marginRight: (index + 1) % 3 === 0 ? '0' : '1rem'
    }"
       @mouseenter="handleMouseEnter"
       @mouseleave="handleMouseLeave"
       @click="handleClick(conformation.num)"
  >

    <div class="conformationIcon"
         ref="conformation-icon"
      :style="{
        backgroundImage : this.selected ?
        `url(//${conformation.savedUrl}check.png)`
        : `url(//${conformation.savedUrl}contactus/${conformation.contactUsImage})`
         ,
        backgroundColor : this.selected ? this.selectedBackgroundColor : this.unselectedBackgroundcolor ,

      }"
    >
    </div>

    <div class="conformationName"
         ref="conformation-name"
         :style="{
          backgroundColor : this.selected ? this.selectedBackgroundColor : this.unselectedBackgroundcolor ,
          color : this.selected ? '#fff' : '#000'
         }"
    >
      {{conformation.name}}
      <div ref="conformation-comment">
        {{conformation.comment !== '' ? `(${conformation.comment})` : ``}}
      </div>
    </div>

  </div>
</template>

<script>
    import { mapGetters , mapState , mapActions , mapMutations } from 'vuex'

    export default {
        name: "category-contact-us",
        props : ['conformation' , 'index' , 'selectedConformations'],
        methods : {
          ...mapMutations('contactUsStore' , ['SET__SELECTED__CONFORMATIONS']) ,
          handleMouseEnter (evt) {
            if(!this.selected) {
              this.$refs['conformation-icon'].style.backgroundColor = '#96d7e8';
              this.$refs['conformation-name'].style.backgroundColor = '#96d7e8';
              this.$refs['conformation-name'].style.color = '#fff';
            }
          },
          handleMouseLeave (evt) {
            if(!this.selected){
              this.$refs['conformation-icon'].style.backgroundColor = '#fff';
              this.$refs['conformation-name'].style.backgroundColor = '#fff';
              this.$refs['conformation-name'].style.color = '#000';
            }
          },
          handleClick (num) {
            //this.selected = !this.selected;
            this.SET__SELECTED__CONFORMATIONS(num);
          },
        },
        watch : {
          selectedConformations (isSelected) {
            //console.log(isSelected);
            this.selected = isSelected.includes(this.conformation.num);
            //this.selected = this.conformation.num === isSelected;
          },
        },
        data () {
          return {
            selected : false ,
            selectedBackgroundColor : '#96d7e8' ,
            unselectedBackgroundcolor : '#fff' ,
          }
        }
        /*computed : {
          ...mapState('contactUsStore' ,
            [
              'conformations' ,
              'selectedConformations' ,
              'selectedSpectificity' ,
            ]
          )
        } ,*/
    }
</script>

<style scoped lang="scss">
  .category {
    width:calc(100%/3.15);
    display: flex;
    flex-direction: row;
    //margin-right:0.5rem;
    cursor: pointer;
    margin:0.5rem 0;
    .conformationIcon{
      width:130px;
      height:130px;
      //background-image: url("//asdfasdf");
      //background-image: url("");
      //background-position: center;
      background-color: #ffffff;
      background-position: center;
      background-repeat: no-repeat;
      margin-right:0.3rem;
    }
    .conformationName{
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #ffffff;
      flex:1;

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/menu/ContactUs/Category.vue